module.exports = __webpack_public_path__ + "static/media/20_000001.14877484.jpg";